import React from "react";
import { TriangleAlertIcon } from "lucide-react";
import { useElapsedTimer } from "../hooks/useElapsedTimer";
import { formatTime } from "../utils/timeFormatter";

const ElapsedTimerDisplay = ({ startTime, isOverdue }) => {
	const elapsedSeconds = useElapsedTimer(startTime);
	const formattedTime = formatTime(elapsedSeconds);

	return (
		<div
			className={`w-full max-w-sm mb-8 ${
				isOverdue ? "bg-red-100" : "bg-gray-200"
			} rounded-lg p-4`}
		>
			<div className="flex justify-center items-center">
				{isOverdue && (
					<TriangleAlertIcon className="w-5 h-5 mr-2 text-red-600" />
				)}
				<span className="text-base font-semibold text-black">
					Time Elapsed: {formattedTime}
				</span>
			</div>
		</div>
	);
};

ElapsedTimerDisplay.displayName = "ElapsedTimerDisplay";

export default ElapsedTimerDisplay;
